import { Injectable, NgZone } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { DeviceHelperService } from './device-helper.service';
import { UserService } from './user.service';

@Injectable({
	providedIn: 'root'
})
export class BackButtonService {
	public listDialog: any[] = [];

	public isTest = false;

	public isStartedNotServer = true;

	constructor(
		private zone: NgZone,
		private location: Location,
		private router: Router,
		private deviceHelper: DeviceHelperService,
		private _userService: UserService
	) {}

	startService() {
		if (this.isTest) {
			this.isStartedNotServer = false;

			let me = this;
			document.addEventListener(
				'keydown',
				(event) => {
					me.backPressProcess();

					event.preventDefault();
				},
				false
			);
		}

		if ((navigator as any).app && (navigator as any).app.overrideBackbutton) {
			this.isStartedNotServer = false;
			(navigator as any).app.overrideBackbutton(true);
			let me = this;
			document.addEventListener(
				'deviceready',
				(event) => {
					document.addEventListener(
						'backbutton',
						(event) => {
							// run on main thread
							this.zone.run(() => {
								me.backPressProcess();
							});

							event.preventDefault();
						},
						false
					);
				},
				false
			);
		}
	}

	popDialog() {
		var dialog = this.listDialog[this.listDialog.length - 1].dialog;
		if (dialog.close) {
			dialog.close();
		} else if (dialog.dismiss) {
			dialog.dismiss();
		}
	}

	backPressProcess() {
		if (this.isStartedNotServer == true) {
			return;
		}

		let me = this;

		if (this.listDialog.length > 0) {
			this.popDialog();
		} else {
			switch (this.router.url) {
				case '/home/nonhourly':
				case '/home/hourly':
					me.deviceHelper.exitApp(0);
					break;
				case '/jobs/overview':
				case '/message':
				case '/notification':
				case '/menu':
				case '/tasks':
				case '/workorders':
					if (this._userService.IsJobtitleAvailable() == true) {
						this.router.navigate(['home/nonhourly']);
					} else {
						this.router.navigate(['home/hourly']);
					}
					break;
				default:
					this.location.back();
					setTimeout(() => {
						// wait 100ms to get url callback
						me.router.navigate(me.router.url as any);
					}, 100);
					break;
			}
		}
	}

	registerDialog(dialog, needDismissFirst) {
		if (this.isStartedNotServer == true) {
			return;
		}

		let me = this;

		if (this.isTest) {
			if (this.listDialog.length && this.listDialog[this.listDialog.length - 1].needDismissFirst) {
				this.popDialog();
				this.listDialog.pop();
			}

			this.listDialog.push({
				dialog: dialog,
				needDismissFirst: needDismissFirst
			});
			if (dialog.afterClosed) {
				dialog.afterClosed().subscribe((rs) => {
					if (!needDismissFirst) {
						me.listDialog.pop();
					}
				});
			} else if (dialog.afterDismissed) {
				dialog.afterDismissed().subscribe((rs) => {
					if (!needDismissFirst) {
						me.listDialog.pop();
					}
				});
			} else if (dialog.onDidDismiss) {
				dialog.onDidDismiss().then((rs) => {
					if (!needDismissFirst) {
						me.listDialog.pop();
					}
				});
			}
			return;
		}

		if (this.listDialog.length && this.listDialog[this.listDialog.length - 1].needDismissFirst) {
			this.popDialog();
			this.listDialog.pop();
		}
		this.listDialog.push({
			dialog: dialog,
			needDismissFirst: needDismissFirst
		});

		if (dialog.afterClosed) {
			dialog.afterClosed().subscribe((rs) => {
				if (!needDismissFirst) {
					me.listDialog.pop();
				}
			});
		} else if (dialog.afterDismissed) {
			dialog.afterDismissed().subscribe((rs) => {
				if (!needDismissFirst) {
					me.listDialog.pop();
				}
			});
		} else if (dialog.onDidDismiss) {
			dialog.onDidDismiss().then((rs) => {
				if (!needDismissFirst) {
					me.listDialog.pop();
				}
			});
		}
	}
}
